// Recruiting news for a manager since the last game day: recruits who
// committed to the team, and recruits it offered who chose another school.
import { positions } from '@/utils/positions';

// recruits: summary/recruits. Returns [{key, good, text}], the team's own
// commitments first.
export function recruitNews(recruits, league, myId, teams) {
    if (!recruits?.players || !myId || recruits.year !== (league.season.year ?? 1)) return [];
    const day = league.season.day;
    return Object.values(recruits.players)
        .filter(c => c.committedTo && c.committedDay === day &&
            (c.committedTo === myId || c.offers?.includes(myId)))
        .sort((a, b) => (b.committedTo === myId) - (a.committedTo === myId) || a.rank - b.rank)
        .map(c => {
            const name = `${c.fName} ${c.lName}`;
            const what = `${c.stars}★ ${positions[c.pos1 - 1]?.short ?? ''}`.trim();
            return c.committedTo === myId ?
                { key: c.id, good: true, text: `${name} (${what}) committed to you!` } :
                { key: c.id, good: false, text: `${name} (${what}), whom you offered, chose ${teams?.[c.committedTo]?.name ?? 'another school'}.` };
        });
}
